export { HomePageView as default } from './HomePageView';
